
import { defineComponent, onBeforeMount, ref } from 'vue';
import { invokeGetUserRole } from '@/utils/admin/master_service';
import { invokeFeedbackReport } from '@/utils/admin/harvest_report';
import { postApi } from '@/utils/ApiCalls';
import axios, { AxiosError } from 'axios';
// eslint-disable-next-line
// import router from '@/router';
// import { XIcon } from 'vue-feather-icons';

export default defineComponent({
  name: 'ReviewerReport',
  setup() {
    const userRole = ref();
    const errorMessage = ref();
    const successMessage = ref();
    const renderReady = ref(true);
    const showFileUploadBtn = ref(false);
    const file = ref();
    const fileName = ref();
    const resMessage = ref();
    const showErrorMessage = ref(false);

    const selectFile = async (event: any) => {
      const selectedFile = event.target.files[0];
      const selectedFileName = event.target.files[0].name;
      const isFileCSV = selectedFileName.endsWith('.csv');
      if (isFileCSV) {
        file.value = selectedFile;
        console.log('Selected file -->', file.value);
        fileName.value = selectedFileName;
      } else {
        window.alert('Please select a valid csv file');
        file.value = null;
        fileName.value = null;
      }
    };

    const uploadCsvToS3 = async (url: any, csvFile: any) => {
      try {
        let uploadResponse;
        const res = await fetch(`${url}`, {
          method: 'put',
          body: csvFile,
        });
        console.log('uploadCsvToS3 res', res);
        // eslint-disable-next-line prefer-const
        uploadResponse = res;
        console.log('uploadCsvToS3', uploadResponse);
        return uploadResponse;
      } catch (err) {
        console.error(err);
        return err;
      }
    };

    const emailPreviewMapping = async (param: string) => {
      try {
        renderReady.value = false;
        if (param === 'csv') {
          console.log('fileName : ', fileName.value);
          const payload = { file_name: fileName.value };
          console.log('Payload Data', payload);
          const res = await postApi(`/comms/getSignedURL`, payload);
          console.log('GetSigned url data', res.data);
          const preSignedObj = res.data;
          console.log('preSignedObj', preSignedObj.url);
          console.log('File Value -->', file.value);
          const uploadedRes: any = await uploadCsvToS3(preSignedObj.url, file.value);
          if (uploadedRes.status === 200) {
            //const response = await postApi(`/validate/preview/mails`, { file_key: preSignedObj.file_key });
            const response = await postApi(`/comms/validate/segmented`, { file_key: preSignedObj.file_key });

            console.log(response.data);
            file.value = null;
            fileName.value = null;
          }
        }
        renderReady.value = true;
        file.value = '';
        showFileUploadBtn.value = false;
        successMessage.value = 'Successfully validated the file. You should get that over email in next 15 minutes';
        setTimeout(() => {
          successMessage.value = null;
        }, 6000);
      } catch (error) {
        console.log('inside catch');
        if (axios.isAxiosError(error)) {
          const err = error as AxiosError;
          console.log(err.response?.data);
          renderReady.value = true;
          resMessage.value = (err.response?.data as { message: string })?.message;
          console.log(`errorMessage.value ${errorMessage.value}`);
          showErrorMessage.value = true;
          setTimeout(() => {
            showErrorMessage.value = false;
          }, 2000);
        }
      }
    };

    onBeforeMount(async () => {
      try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        renderReady.value = false;
        const role: any = await invokeGetUserRole('/getUserRole');
        userRole.value = role.user_roles;
        if (userRole.value.length > 0) {
          console.log('inside length');
          if (userRole.value.includes('System Admin') || userRole.value.includes('Proxy Admin') || userRole.value.includes('Community Manager') || userRole.value.includes('Knowledge Manager')) {
            renderReady.value = true;
          } else {
            renderReady.value = false;
          }
        }
      } catch (error) {
        console.log('Error in onBeforeMount', error);
        renderReady.value = false;
      }
    });
    return {
      errorMessage,
      successMessage,
      showFileUploadBtn,
      fileName,
      emailPreviewMapping,
      selectFile,
      renderReady,
      resMessage,
      showErrorMessage,
    };
  },
});
